import { useMutation } from '@tanstack/react-query'
import { apiRequest, BASE_API_URL } from '../api-adapters/api-request'

const PAYMENTS_URL = `${BASE_API_URL}/v1/private-payments`

function useStripeCustomerPortal({
  onSuccess,
  onError,
}: {
  onSuccess?: (url: string) => void
  onError?: (error: Error) => void
}) {
  const { isLoading, isError, mutate } = useMutation({
    mutationFn: (returnUrl?: string) => apiRequest.post(
      `${PAYMENTS_URL}/create-portal-session`,
      {
        returnUrl
      }
    ).then((response) => response.data.url),
    onSuccess: (url) => {
      onSuccess?.(url)
    },
    onError: (error: Error) => {
      onError?.(error)
    }
  })

  return {
    isLoading,
    isError,
    mutate,
  }
}

export {
  useStripeCustomerPortal,
}
